import React, { useEffect, useRef, useState } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import PocketBase from "pocketbase";

const initialOptions = {
  "client-id":
    "AcF6WJ9hDUtDBtTnnjwwlP5iyNCRNFO-aZj-4mC9th1QrZbcxhgBPkZJ1zXSMDHB_Kp3Ty2zxXjQWRsS",
  currency: "USD",
  intent: "capture",
};

const pb = new PocketBase("https://friendsofstandrewsstatepark.org");

export default function donations() {
  let orderIDLoc;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [success, setSuccess] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [ErrorMessage, setErrorMessage] = useState("");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [orderID, setOrderID] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (success) {
      alert("Payment successful!!");
    }
    if (ErrorMessage) {
      alert(ErrorMessage);
    }
  }, [success, ErrorMessage]);

  // creates a paypal order
  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Friends of St. Andrew's State Park Membership",
            amount: {
              currency_code: "USD",
              value: donationAmount.current.value,
            },
          },
        ],
      })
      .then((orderID) => {
        orderIDLoc = orderID;
        setOrderID(orderID);
        return orderID;
      });
  };
  // check Approval
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      const data = {
        paypal_order_id: orderIDLoc,
        first_name: payer.name.given_name,
        last_name: payer.name.surname,
        email: payer.email_address,
        payer_id: payer.payer_id,
        amount: donationAmount.current.value,
      };

      const record = async () => {
        await pb.collection("donors").create(data);
      };
      record().then((r) => setSuccess(true));
    });
  };

  //capture likely error
  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  let donationAmount = useRef(0);
  return (
    <div className="content d-flex flex-column justify-content-between fsa-body-bg">
      <NavBar />
      <div className="d-flex flex-column align-items-center px-3 pt-4 pb-5">
        <h1 className="fsa-section-title">Donations</h1>
        <p className="text-center mb-4" style={{ maxWidth: 600 }}>
          Thank you for helping us support St. Andrews State Park. A tribute is
          one of the most meaningful gifts you can give. The Friends of St.
          Andrews State Park, Inc. is a nonprofit charitable citizen support
          organization — all funds raised go directly to support park activities
          and preserve the Florida State Park mission.
        </p>

        <div className="card" style={{ maxWidth: 480, width: "100%" }}>
          <div className="card-header fsa-card-header">
            <h5
              className="mb-0"
              style={{ color: "white", fontFamily: "inherit" }}
            >
              Make a Donation
            </h5>
          </div>
          <div className="card-body">
            <label className="form-label fw-semibold" htmlFor="donationInput">
              Donation Amount (USD)
            </label>
            <input
              id="donationInput"
              ref={donationAmount}
              type="number"
              min="0"
              pattern="\d+"
              step=".01"
              className="form-control mb-3"
              placeholder="Enter amount"
            />
            <PayPalScriptProvider options={initialOptions}>
              <PayPalButtons
                style={{ layout: "vertical" }}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
              />
            </PayPalScriptProvider>
          </div>
          <div
            className="card-body border-top"
            style={{ fontSize: "0.85rem", color: "#555" }}
          >
            <p className="mb-1">
              ✉ Mail checks to: Friends of St. Andrews State Park, 5401 State
              Park Circle, Panama City Beach, FL 32408
            </p>
            <p className="mb-0">
              💳 Most credit cards accepted. Contact us for assistance.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
